import React, {FC} from 'react';
import {Wrapper, ContentHeader, ContentDescription} from "./styles";

const Contacts: FC = () => {
    return (
        <Wrapper>
            <ContentHeader>Контакты</ContentHeader>

            <ContentDescription>
                Oбщество с ограниченной ответственностью "Игрунка Геймс"
            </ContentDescription>
            <ContentDescription>
                Адрес: 194156, Россия, Санкт-Петербург, вн.тер.г. муниципальный округ Светлановское, ул. Манчестерская, д. 5, к. 1, стр. 1, кв. 844
            </ContentDescription>
            <ContentDescription>
                ОГРН: 1237800135759
            </ContentDescription>
            <ContentDescription>
                ИНН: 7802947367
            </ContentDescription>
            <ContentDescription>
                КПП: 780201001
            </ContentDescription>
            <ContentDescription>
                Код вида деятельности по коду Минцифры России: 1.01
            </ContentDescription>
            <ContentDescription>
                Эл. почта: igunkastudio@yandex.ru
            </ContentDescription>
            <ContentDescription>
                Телефон: +7 (921) 744-20-76
            </ContentDescription>
        </Wrapper>
    );
}

export default Contacts;